import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useStopDictate(): () => void {
  return useWebChatAPIContext().stopDictate;
}
